$ = require 'jquery'
router = require './../components/router'
auth = require './../components/auth'

resizer = require 'iframe-resizer'

class Header
  applyLogin_new: ->
    $cont = $('#aspnetForm table td:eq(1)')
    $cont.addClass('login-form')
#    $login = $cont.find('input[type="text"]')
#    $pass = $cont.find('input[type="password"]')
#    $login.addClass('login-field')
#    $pass.addClass('password-field')

  applyLogin: ->
    console.log 'Добавляю форму аутентификации'

    # На этих страницах нет формы
    no_auth_pages = ['PersonalRegistration', 'PersonalPage', 'PartnerRegistration', 'passwordRecovery', 'passwordrecovery']
    if no_auth_pages.indexOf(router.page()) != -1
      $('.login').addClass('no-auth').empty()
      return

    old_cont = $('#aspnetForm table td:eq(1)')

    if not auth.logged()
      # adding new block after menu
      $menu = $('.nav')
      $full = $ '<div/>',
        class: 'login-full'
      $menu.after($full)
      $full.append $('.login form')

      # inputs
      $ncont = $('.login-full .inputs')
      $ncont.prepend $('<div class="msg">Войдите или зарегистрируйтесь, чтобы забронировать тур:</div>')
      $('.login').addClass('no-auth')
    else
      $ncont = $('.login .inputs')
#    $ncont.find('input').remove()
    $login = old_cont.find('input[type="text"]')
    $pass = old_cont.find('input[type="password"]')
    $submit = old_cont.find('input[type="submit"]')
#    $login.attr('placeholder', 'Логин').css('width', '')
#    $pass.attr('placeholder', 'Пароль').css('width', '')
#    $submit.val('Войти')
#    $ncont.append($login)
#    $ncont.append($pass)
#    $ncont.append($submit)

    $nlogin = $ncont.find('input[type="text"]')
    $npass = $ncont.find('input[type="password"]')
    $nsubmit = $ncont.find('input[type="submit"]')
    $nsubmit.closest('form').on 'submit', (e) ->
      e.preventDefault()
      $login.val($nlogin.val())
      $pass.val($npass.val())
      $submit.click()
      console.log $nlogin.val()
      console.log $login.val()
      console.log $npass.val()

    #links
    $reg = null
    $regp = null
    $lk = null
    $exit = null
    $fog = null

    username = ''
    isLogged = true
    old_cont.find('a').each (i, e) ->
      console.log 'menu', i, e
      if $(e).text() == 'Личный кабинет'
        $lk = $(e)
        console.log 'lk', i, e
      if $(e).text() == 'Выход'
        console.log 'exit', i, e
        $exit = $(e)
      if $(e).text() == 'Регистрация партнёра'
        console.log 'reg part', i, e
        $regp = $(e)
      if $(e).text() == 'Регистрация'
        console.log 'reg', i, e
        console.log '======2-==='
        $reg = $(e)
        $reg.attr('target', '_blank')
      if $(e).text() == 'Забыли пароль?'
        console.log 'fog', i, e
        $fog = $(e)
        $fog.attr('target', '_blank')
        console.log('====1=====')

      if $(e).text() == 'Вы не авторизованы'
        isLogged = false

      if /^Ваш логин /.test $(e).text()
        username = $(e).text().substr(10)
        console.log 'new username', username

    console.log 'logged', isLogged

    if auth.logged()
      $ncont = $('.login .links')
    else
      $ncont = $('.login-full .links')

    # Заглушки в шаблоне, могут правращаться
    # в разные ссылки на разных страницах
    $link1 = $ncont.find('a:eq(0)') # Вход
    $link2 = $ncont.find('a:eq(1)') # Регистрация

    if $regp # and $reg.length
      # Регистрация партнера
      console.log('Ссылка на регистрацию партнера найдена')
      $regp.text('Регистрация (нет договора)')
      $link2.replaceWith($regp)
    else if $reg # and $reg.length
      # Регистрация
      console.log('Ссылка на регистрацию туриста найдена')
      $reg.text('Регистрация')
      $reg.attr('href', '/personalregistration.aspx')
      $link2.replaceWith($reg)
    else
      console.log('Ссылки на регистрацию не найдены')
      if router.site() == 'personal'
        $link2.text('Регистрация')
        $link2.attr('href', '/personalregistration.aspx')
      else
        $link2.attr('href', '/PartnerRegistration.aspx')

#    if $fog # and $fog.length
#      $link2.replaceWith($fog)

    if $lk # and $lk.length
      $lk.text('Настройки')
      $link1.replaceWith($lk)

    if $exit # and $exit.length
      $link2.replaceWith($exit)

    if router.site() == 'personal'
      if router.page() == 'AutobusQuotes'
        $link1.replaceWith($fog)
        $link1.removeClass('signin')
      if router.page() == 'SimpleBasket'
        $slash = $ '.slash'
        console.log($slash)
        $slash = $slash.clone()
        $slash.appendTo $ncont
        $link3 = $ '<a/>'
        $link3.appendTo $ncont
        $link3.replaceWith($fog)

#    if router.site() == 'online'
#      $reg = old_cont.find('a:eq(3)')
#      $fog = old_cont.find('a:eq(2)')
#    else
#      $reg = old_cont.find('a:eq(2)')
#      $fog = old_cont.find('a:eq(3)')
#    $ncont.find('a:eq(0)').replaceWith($reg)
#    $ncont.find('a:eq(1)').replaceWith($fog)

#    $ncont = $('.login .inputs')
#    $state = old_cont.find('a:eq(0)')
#    state = $state.text()
#    console.log 'state', state
#    if state == 'Справка'
#      isLogged = false
#    else
#      isLogged = state != 'Вы не авторизованы'

    console.log 'nav', $('.nav')

    $ncont = $('.login .inputs')
    if isLogged
#      username = state.substr(10)
#      console.log 'username', username

      $ncont.find('input').remove()
#      $reg.text('Настройки')

      if username
        $user = $('<div />',
          class: 'user-info'
        )
        $user.append($('<div>Вы вошли как:</div>'))
        $user.append($('<div>' + username + '</div>'))

        $ncont.append($user)

    # Спрятать дефолтную строчку с логином
    $('#aspnetForm table tr:eq(0)').hide()
    $('#aspnetForm table tr:eq(1)').hide()

  applyMenu: ->
    console.log 'Примеряю стили меню'
    base = ''
    site = router.site()
    server = router.server()
    if server == 'test'
      if site == 'online'
        base = '/ttv_mw_22'
      if site == 'personal'
        base = '/ttv_personal_22'
    else
      base = ''
    if site = 'personal'
      $('.nav li.autobus_quotes a').attr('href', "//www.tourtrans.ru/tours/search/svetofor.html")
    else
      $('.nav li.autobus_quotes a').attr('href', "#{base}/Extra/AutobusQuotes.aspx")
    $('.nav li.order_list a').attr('href', "#{base}/orderlist.aspx#")
    $('.nav a:eq(2)').attr('href', "#{base}/orderlist.aspx#documents")
    $('.nav a:eq(3)').attr('href', "#{base}/orderlist.aspx#commission")
    $('.nav a:eq(4)').attr('href', "#{base}/orderlist.aspx#bonuses")
    $('.nav a:eq(5)').attr('href', "#{base}/PartnerRegistration.aspx")
    $('.nav a:eq(6)').attr('href', "//online.tourtrans.ru/OrderStatus.aspx")
    $('.nav a:eq(7)').attr('href', "//online.tourtrans.ru/VisaStatus.aspx")

#    if site == 'personal'
#      $('.nav li:eq(2)').hide()
#      $('.nav li:eq(3)').hide()
#      $('.nav li:eq(4)').hide()
#      $('.nav li:eq(5)').hide()
#
#    if site == 'online'
#      $('.nav li:eq(6)').hide()
#      $('.nav li:eq(7)').hide()

#    # Ссылка на список заявой, подставим в меню если присутствует
#    $requests = $('#ctl00_menuLeft_lnkOrderList')
#    if $requests.length > 0
#      $('.nav a:eq(1)').replaceWith
#    else
#      $('.nav li:eq(1)').remove()

  applyBanner: ->
    $banner = $ '<div/>',
      class: 'online-banner'
    $iframe = $ '<iframe/>',
      id: 'online-banner'
      src: '//www.tourtrans.ru/pages/for-agencies/banner.html?iframe=true'

    done = false
    handler = ->
      resizer.iframeResize
        autoResize: true
        bodyPadding: '0 0 5px'
        onResized: (data) ->
          $iframe.off 'load'
          if not done
            if data.height > 5
              $('.nav').after($banner)
            else
              $banner.hide()
            done = true
      , '#online-banner'

    $iframe.on 'load', handler

    $banner.append $iframe
    # $('body').append($banner)
    $('.nav').after($banner)

#    $wrapper.append $iframe

module.exports = new Header